import RootState from 'typings/RootState'
import { Event } from 'Store/common/common.types'
import { ListData, PermissionData } from './types'

export const selectPermissionListEvent = (state: RootState): Event => state.managePermissionReducer.listEvent

export const selectPermissionList = (state: RootState): ListData => state.managePermissionReducer.list

export const selectPermissionActionEvent = (state: RootState): Event =>
  state.managePermissionReducer.actionEvent

export const selectPermissionDetail = (state: RootState): PermissionData | undefined =>
  state.managePermissionReducer.detail

export const selectPermissionDetailEvent = (state: RootState): Event =>
  state.managePermissionReducer.detailEvent

export const selectAllPermissionList = (state: RootState): PermissionData[] =>
  state.managePermissionReducer.allPermission
